import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

export const CountriesQuery = gql`
  query countries($search: String) {
    countries(where: {
      search: $search
    }) {
      id
      name
      title
      parentCountryId
      VATrate
      code
      flag
      currencyId
      currency {
        id
        value
      }
      languageId
      language {
        id
        value
      }
      business {
        id
        name
      }
      weightUnit
      bankName
      iban
      swift
      bankAccountNumber
      states {
        id
        name
        title
        vatRate
      }
    }
    languages {
      id
      value
    }
  }
`;

const CreateCountryMutation = gql`
  mutation($country: CountryInput!) {
    createCountry(country: $country) {
      id
    }
  }
`;

const UpdateCountryMutation = gql`
  mutation($id: String!, $country: CountryInput!) {
    updateCountry(id: $id, country: $country) {
      id
    }
  }
`;

const DeleteCountryMutation = gql`
  mutation($id: String!) {
    deleteCountry(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface Response {
  data: any;
}

class GetCountriesQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const { countries, createCountry, updateCountry, deleteCountry }: any = this.props;
    return this.props.children({ countries, createCountry, updateCountry, deleteCountry });
  }
}

export default compose(
  graphql<IInputProps, Response>(CountriesQuery, {
    name: 'countries'
  }),
  graphql<IInputProps, Response>(CreateCountryMutation, {
    name: 'createCountry'
  }),
  graphql<IInputProps, Response>(UpdateCountryMutation, {
    name: 'updateCountry'
  }),
  graphql<IInputProps, Response>(DeleteCountryMutation, {
    name: 'deleteCountry'
  })
)(GetCountriesQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Countries/Countries.tsx